import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const MarqueeStyle = {
  index: css`
    padding: 2px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  marquee: css`
    flex: 1;
    .item {
      height: 22px;
      padding: 0 8px;
      color: ${theme.colors.white};
      font-size: 12px;
      line-height: 22px;
      background-color: ${theme.colors.black};
    }
  `,
  notiLeft: css`
    color: ${theme.colors.white};
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    svg {
      fill: ${theme.colors.orange[200]};
      margin-left: 8px;
    }

    span {
      display: inline-block;
      vertical-align: middle;
      font-weight: 700;
      font-size: 12px;
      padding: 0 4px;
    }
  `,
};
